import { RulesOperators } from "@/models/business-rules/RulesOperators";

export const ruleOperators: RulesOperators[] = [
  {
    value: "and",
    operator: "and"
  },
  {
    value: "or",
    operator: "or"
  }
];
